import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    supportedLngs: ["en", "he", "es", "pt"],
    ns: ["translation"],
    defaultNS: "translation",
    backend: {
      loadPath: "/locales/{{lng}}/translation.json",
      requestOptions: { cache: "no-cache" }
    },
    interpolation: { escapeValue: false }
});

async function fetchAndAddTenantBundle(lang, tenant) {
  try {
    const res = await fetch(`/locales/${lang}/${tenant}/translation.json`, { cache: "no-cache" });
    if (!res.ok) return false;
    const data = await res.json();
    i18n.addResourceBundle(
      lang,
      "translation",
      data,
      true, // deep merge
      true  // overwrite
    );
    return true;
  } catch {
    return false;
  }
}

export async function loadTenantTranslations(lang, tenant) {
  // Always load the English tenant bundle as a fallback so missing keys in
  // non-English languages fall back to the English string rather than the
  // raw translation key.
  await fetchAndAddTenantBundle("en", tenant);

  if (lang && lang !== "en") {
    await fetchAndAddTenantBundle(lang, tenant);
  }

  i18n.reloadResources([lang, "en"].filter(Boolean), "translation");
}

export const languages = [
  { name: "Español", value: "sp" },
  { name: "عربيه", value: "ar" },
  { name: "English", value: "en" },
  { name: "Pусский", value: "ru" },
  { name: "עברית", value: "he" },
  { name: "Português", value: "pt" },
];

export default i18n;